import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Button } from '@redturtle/volto-io-studio/components';
import config from '@plone/volto/registry';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import './DefaultSlideAppearance.less';

const messages = defineMessages({
  vedi: {
    id: 'Vedi',
    defaultMessage: 'Vedi',
  },
});

const DefaultAppearance = ({ item, TitleTag, isEditMode, index, data }) => {
  const intl = useIntl();
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div className="default-appearance">
      <div className="ui container">
        <div className="item-wrapper">
          {item.image && (
            <div className="image">
              <Image
                alt={item.title}
                title={item.title}
                item={item}
                responsive={true}
              />
            </div>
          )}
          <div className="text">
            <TitleTag>{item.title ? item.title : item.id}</TitleTag>
            <p>{item.description?.slice(0, 500) + '...'}</p>
            <Button
              href={isEditMode ? '#' : flattenToAppURL(item['@id'])}
              as={UniversalLink}
              color={'outline'}
              inverted
            >
              {data?.item_detail_label || intl.formatMessage(messages.vedi)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DefaultAppearance;
